import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role that holds an `interview_compliance_run`, `interview_checklist_manage` or
 * `interview_compliance_oversight` capability (capabilities.ts) for the Phase 2 AI
 * Interview Compliance Assistant (PRO-1120, ADR-056 A1). Mirrors the server
 * role→capability map; `L6_PLATFORM_ADMIN` is DELIBERATELY absent (ADR-018 EoP — never
 * an HR shortcut). Extracted into this dependency-light module so the `AppRoutes` route
 * guard can import it without pulling the lazy-loaded `InterviewComplianceSurface` into
 * the initial bundle (mirrors `peopleAssistantRoles.ts`).
 */
export const HR_INTERVIEW_COMPLIANCE_ROLES: readonly StaffRole[] = [
  'HR_INTERVIEW_MANAGER',
  'HR_RECRUITMENT_COMPLIANCE_LEAD',
];
